import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa-stack fa-lg",
  title: "Insufficient data to check consistency"
}
const _hoisted_2 = {
  key: 1,
  class: "fa-stack fa-lg",
  title: "Inconsistencies detected"
}
const _hoisted_3 = {
  key: 2,
  class: "fa-stack fa-lg"
}
const _hoisted_4 = {
  key: 3,
  class: "fa-stack fa-lg"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsistencyAnalysisCircles',
  props: {
    status: {},
    size: { default: 2 }
  },
  emits: ["show-consistency-analysis"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    function emitShowConsistencyAnalysis()
    {
        emit('show-consistency-analysis')
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onClick: emitShowConsistencyAnalysis }, [
    (__props.status === 'Unknown')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa fa-circle text-light", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */),
          _createElementVNode("i", {
            class: _normalizeClass(["fa-regular fa-circle", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    (__props.status === 'Inconsistent')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa fa-circle text-danger", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */),
          _createElementVNode("i", {
            class: _normalizeClass(["fa-regular fa-face-frown", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    (__props.status === 'Acceptable')
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa fa-circle text-warning", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */),
          _createElementVNode("i", {
            class: _normalizeClass(["fa-regular fa-face-meh", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    (__props.status === 'Consistent')
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createElementVNode("i", {
            class: _normalizeClass(["fa fa-circle text-success", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */),
          _createElementVNode("i", {
            class: _normalizeClass(["fa-regular fa-face-smile", `fa-stack-${__props.size}x`])
          }, null, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})